// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dPtt","colBig":"styles_colBig__27W6G","colSmall":"styles_colSmall__1M-_K","shopifyNameWrapper":"styles_shopifyNameWrapper__1JjhG"};